export default __webpack_public_path__ + "static/news10-9256ea517418253bb14f9469367f17f7.jpeg";